import React from "react";

export const RecursiveApp: React.FC = () => {
  return (
      <iframe
        src="https://www.ranjan.fyi"
        style={{ width: '100%', height: '100%' }}
        title="WebView"
      />
  );
};

export default RecursiveApp;